/**
 * @author Ilya Aderiho
 */
var BpNotificationsController = (function () {
    function BpNotificationsController($state, $scope, socket, topic, env, settings, notify, $attrs, status) {
        var _this = this;
        this.$state = $state;
        this.$scope = $scope;
        this.socket = socket;
        this.topic = topic;
        this.env = env;
        this.settings = settings;
        this.notify = notify;
        this.$attrs = $attrs;
        this.status = status;
        this.lockEnabled = false;
        this.OPP_VERSION_3 = 3;
        this.showBpNotifications = false;
        this.notificationsArray = [];
        this.submitting = true;
        this.sources = {};
        this.fileUploaded = false;
        this.fileList = this.topic.topic.files;
        ;
        this.socket.forward("eligibility.extractNotifications", this.$scope);
        this.$scope.$on('socket:eligibility.extractNotifications', function (event, data) {
            if (data.success) {
                _this.notificationsArray = data.data;
            }
        });
    }
    BpNotificationsController.prototype.showHide = function () {
        this.showBpNotifications = this.showBpNotifications ? false : true;
    };
    BpNotificationsController.prototype.showBpNotification = function (item, event) {
        var data = {
            email: item.mailData.email.join(', '),
            from: item.mailData.from,
            subject: item.mailData.subject,
            html: item.mailData.html
        };
        this.status.displayNotificationPreview(event, data, (function (err) {
        }));
    };
    BpNotificationsController.prototype.downloadAttachment = function (attachment) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    name: attachment
                },
                function: 'downloadBpNotificationAttachment',
                script: '/mysa-attachments/maGate',
                token: this.env.user.token
            }
        });
    };
    BpNotificationsController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                bID: this.topic.topicBrowserID,
                data: { opportunityId: this.topic.topic._id.substring(4) },
                function: 'extractOpportunityNotifications',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token
            }
        });
    };
    BpNotificationsController.$inject = ['$state', '$scope', 'socket', 'topic', 'env', 'settings', 'notify', '$attrs', 'status'];
    return BpNotificationsController;
}());
var BpNotificationsComponent = (function () {
    function BpNotificationsComponent() {
        this.templateUrl = 'bp-notifications.html';
        this.controllerAs = 'vm';
        this.controller = BpNotificationsController;
    }
    return BpNotificationsComponent;
}());
angular
    .module('application')
    .component('bpNotificationsSection', new BpNotificationsComponent());

//# sourceMappingURL=bp-notification.component.js.map
